<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Trouble Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                @click="helpView = !helpView">
                                <i class="fas fa-question-circle"></i>
                                Help
                            </button>
                        </div>
                        <transition>
                            <div v-show="helpView">
                                <div style="height: 20px;"></div>
                                <div>
                                    <div class="form-group">
                                        <h4>What happens during a recheck?</h4>
                                        <p class="form-text mt-0">
                                            <br />
                                            <b>Online:</b> connect via SSH.<br /><br />
                                            <b>PMTA Commander:</b> run SSH cmd "/etc/init.d/pmta-commander status" that should return "pmta-commander-worker is running"<br /><br />
                                            <b>Statictics:</b> get and process data via HTTP from http://server.ip/get_stats.php<br /><br />
                                            <b>Campaign status:</b> get and process data via HTTP from PMTA WEB API https://server.ip:9999/command using command "show jobs --maxitems=9999"<br /><br />
                                            <b>Config status:</b> uploads(if need) configuration files to PMTA servers via SSH<br /><br />
                                            <b>Queue Occupancy:</b> get and process data via HTTP from PMTA WEB API https://server.ip:9999/command using command "show vmtas --maxitems=9999"<br /><br />
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group" v-if="this.$store.getters.isAdmin">
                            <label>User</label>
                            <treeselect placeholder="All" v-model="filter.userId" :multiple="false" :options="userList"
                                :load-options="loadUserList" :auto-load-root-options="true" />
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                    @click="getReport()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{ preloader: loading }"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length < 1">{{ emptyMessage }}</div>
                            <div v-else>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th @click="tableOrdering('pmtaServerId')">
                                                        <span role='button'>ID</span>
                                                    </th>
                                                    <th @click="tableOrdering('pmtaServerName')">
                                                        <span role='button'>Name</span>
                                                    </th>
                                                    <th @click="tableOrdering('pmtaServerIp')">
                                                        <span role='button'>IP</span>
                                                    </th>
                                                    <th v-for="(label, key) in troubleList" :key="key">
                                                        <span role='button'>{{ label }}</span>
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in report" :key="index">
                                                    <td class="align-middle">{{ row.pmtaServerId }}</td>
                                                    <td class="align-middle">
                                                        <router-link
                                                            :to="{ name: 'pmtaServerEdit', params: { id: row.pmtaServerId } }">
                                                            {{ row.pmtaServerName }}
                                                        </router-link>

                                                    </td>
                                                    <td class="align-middle">{{ row.pmtaServerIp }}</td>
                                                    <td class="align-middle" v-for="(label, troubleKey) in troubleList"
                                                        :key="troubleKey">
                                                        <h3 class="mb-0">
                                                            <span
                                                                v-bind:class="[!(row.troubles[troubleKey]) ? smileClass : sadClass]"></span>
                                                        </h3>
                                                    </td>
                                                    <td>
                                                        <button type="button" class="btn btn-info btn-sm"
                                                            @click="recheck(row.pmtaServerId, index)">
                                                            <i v-if="loadingRecheck === null" class="fas fa-sync"></i>
                                                            <i v-if="loadingRecheck === index"
                                                                class="spinner-grow spinner-grow-sm" role="status"></i>
                                                            Recheck
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import Swal from 'sweetalert2';
import Preloader from '../components/Preloader';
import Breadcrumb from '../components/Breadcrumb';
import ReportService from '../services/ReportService';
import UserService from '../services/UserService';

export default {
    name: 'PmtaTroubleReport',
    components: {
        Treeselect,
        Breadcrumb,
        Preloader,
    },
    data() {
        return {
            troubleList: [],
            report: [],
            emptyMessage: 'Click on "Get" to get the data.',
            userList: null,
            filter: {
                userId: null,
                orderBy: 'pmtaServerId',
                asc: true
            },
            loading: false,
            loadingRecheck: null,
            smileClass: 'ti-face-smile text-success',
            sadClass: 'ti-face-sad text-danger',
            helpView: false
        }
    },
    mounted() {
    },
    methods: {
        recheck(pmtaServerId, reportLine) {
            this.loadingRecheck = reportLine;
            ReportService.recheckPmtaTrouble(JSON.stringify({ 'pmtaServerId': pmtaServerId })).then(response => {
                if (response.status !== 200) {
                    Swal({
                        type: 'error',
                        title: 'Error',
                        text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    });
                    this.loadingRecheck = null;
                    return;
                }
                let recheckedData = response.data.recheckedData;
                this.report.forEach((reportLine, index) => {
                    if (reportLine.pmtaServerId === recheckedData.pmtaServerId) {
                        this.report[index] = recheckedData;
                    }
                });
                this.loadingRecheck = null;
                let recheckedDataText = '';
                Object.entries(recheckedData.troubles).forEach(trouble => {
                    if (trouble[1] === true) {
                        recheckedDataText += this.troubleList[trouble[0]] + '</br>';
                    }
                });
                recheckedDataText = recheckedDataText !== '' ? recheckedDataText : 'No trouble';
                Swal({
                    title: 'Existing PMTA troubles',
                    html: recheckedDataText
                });
            }).catch(error => {
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                });
                this.loadingRecheck = null;
            });
        },
        loadUserList({ callback }) {
            UserService.getUserSelect().then(response => {
                this.userList = response.data['hydra:member'].map(user => {
                    return { id: user.id, label: user.username }
                });
                callback();
            });
        },
        getReport: function () {
            this.loading = true;
            ReportService.getPmtaTroubleReport(JSON.stringify(this.filter)).then(response => {
                if (response.status !== 200) {
                    Swal({
                        type: 'error',
                        title: 'Error',
                        text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    });
                    this.loading = false;
                    return;
                }
                this.report = response.data.report;
                this.troubleList = response.data.troubles;
                this.emptyMessage = 'No data found.';
                this.loading = false;
            }).catch(error => {
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                });
                this.loading = false;
            });
        },
        tableOrdering(field) {
            if (this.filter.orderBy === field) {
                this.filter.asc = !this.filter.asc;
            } else {
                this.filter.orderBy = field;
                this.filter.asc = false;
            }
            this.getReport();
        }
    }
}
</script>

<style scoped>
tbody {
    font-size: 14px;
    font-family: Arial, serif;
}
</style>
